import { defineMessages } from "react-intl";

const baseId = "t.pages.TasksManagement.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "APPROVAL MANAGEMENT",
  },
});
